import type { ElementType, ReactNode } from 'react';
import { cx } from '@/lib/cx';
import styles from './Eyebrow.module.css';

export interface EyebrowProps {
  children: ReactNode;
  /** `navy` (por defecto) o `gold`, segun el mockup de cada seccion. */
  ink?: 'navy' | 'gold' | 'tone';
  align?: 'start' | 'center';
  /** Destellos a los lados, como "+ GIRA 2027 +" en el hub. */
  withSparkles?: boolean;
  as?: ElementType;
  className?: string;
}

/** Ceja en small caps con tracking alto (Cinzel). El rasgo mas repetido del set. */
export function Eyebrow({
  children,
  ink = 'navy',
  align = 'start',
  withSparkles = false,
  as: Tag = 'p',
  className,
}: EyebrowProps) {
  return (
    <Tag className={cx('az-eyebrow', styles.eyebrow, styles[ink], styles[`align-${align}`], className)}>
      {withSparkles ? <span className={styles.spark} aria-hidden="true" /> : null}
      <span className={styles.text}>{children}</span>
      {withSparkles ? <span className={styles.spark} aria-hidden="true" /> : null}
    </Tag>
  );
}
